<template>
  <div class="scene-elememt-container">
    <div class="menu-box">
      <div class="group-box">
        <div
          v-if="isChecked('Project.Single.DataSet.Bim')"
          :class="getClassName('Bim')"
          @click="openDataSetPanel('Bim')">
          <div class="icon-box">
            <icon-svg icon-class="ic-moxing" />
          </div>
          <div>BIM</div>
        </div>
        <div
          v-if="isChecked('Project.Single.SceneComponentTree.AddNode')"
          :class="getClassName('Entity')"
          @click="openElementPanel">
          <div class="icon-box">
            <icon-svg icon-class="ic-yuanjian" />
          </div>
          <div>构件</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.Osgb')"
          :class="getClassName('Osgb')"
          @click="openDataSetPanel('Osgb')">
          <div class="icon-box">
            <icon-svg icon-class="ic-qxsy" />
          </div>
          <div>倾斜摄影</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.PointCloud')"
          :class="getClassName('PointCloud')"
          @click="openDataSetPanel('PointCloud')">
          <div class="icon-box">
            <icon-svg icon-class="ic-dy" />
          </div>
          <div>点云</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.Rs')"
          :class="getClassName('Rs')"
          @click="openDataSetPanel('Rs')">
          <div class="icon-box">
            <icon-svg icon-class="ic-yg" />
          </div>
          <div>遥感影像</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.Wmts')"
          :class="getClassName('Wmts')"
          @click="openDataSetPanel('Wmts')">
          <div class="icon-box">
            <icon-svg icon-class="ic-WMTS" />
          </div>
          <div>WMTS</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.Vector')"
          :class="getClassName('Vector')"
          @click="openDataSetPanel('Vector')">
          <div class="icon-box">
            <icon-svg icon-class="ic-shiliangwapian-2" />
          </div>
          <div>矢量</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.CadTree')"
          :class="getClassName('Cad')"
          @click="openDataSetPanel('Cad')">
          <div class="icon-box">
            <icon-svg icon-class="ic-CADwapian" />
          </div>
          <div>二维图纸</div>
        </div>
      </div>
      <div class="group-box">
        <div
          class="button-box"
          :class="getClassName('Extrude')"
          @click="openCreateExtrudePanel">
          <div class="icon-box">
            <icon-svg icon-class="ic-kaiwa" />
          </div>
          <div>开挖</div>
        </div>
        <div
          v-if="isChecked('Project.Single.DataSet.Bim')"
          :class="getClassName('Water')"
          @click="openCreateWaterPanel">
          <div class="icon-box">
            <icon-svg icon-class="ic-shuimian" />
          </div>
          <div>水面</div>
        </div>
      </div>
      <!-- <div class="group-box"></div> -->
      <!-- <div class="group-box"></div> -->
    </div>
    <div class="scene-content-box">
      <div class="scene-data-box">
        <div
          :class="`collapse-btn-box ${isCollapse ? 'collapse' : ''}`"
          @click="toggleCollapsePanel">
          <div class="icon-box">
            <i class="el-icon-arrow-right icon-rotate icon"></i>
            <!-- <icon-svg icon-class="icon-zhankai" /> -->
          </div>
        </div>
        <SceneDataPanel
          ref="sceneDataPanel"
          v-show="!isCollapse && !isPosEditMode"
          :sceneInfo="sceneInfo"
          :sceneData="originSceneData"
          :currDataSetFolder="currDataSetFolder"
          :updateCurrDataSetFolder="updateCurrDataSetFolder"
          :updateSceneTree="updateSceneTree"
          :elemAddMode="elemAddMode"
          :currEditElem="currEditElem"
          :updateCurrEditElem="updateCurrEditElem"
          :updateElemEditMode="updateElemEditMode"
          :updateCurrEntity="updateCurrEntity"
          :showBVShp="showBVShp"
          :unloadDataSets="unloadDataSets"
          :unloadEntities="unloadEntities"
          :showDataSets="showDataSets"
          :hideDataSets="hideDataSets"
          :highLightDataSets="highLightDataSets"
          :highLightEntities="highLightEntities"
          :openMoveToDialog="openMoveToPanel"
          :enterPosEditMode="enterPosEditMode"
          :openPrioritySettingPanel="openPrioritySettingPanel"
          :openCADSettingPanel="openCADSettingPanel"
          :openVectorSettingPanel="openVectorSettingPanel"
          :openEditWaterPanel="openEditWaterPanel"
          :openEditExtrudePanel="openEditExtrudePanel"
          :highLightWaters="highLightWaters"
          :showWaters="showWaters"
          :hideWaters="hideWaters"
          :highLightExtrudes="highLightExtrudes"
          :showExtrudes="showExtrudes"
          :hideExtrudes="hideExtrudes" />
        <SceneEditDataPanel
          ref="scenePosEditDataPanel"
          v-show="!isCollapse && isPosEditMode"
          :sceneInfo="sceneInfo"
          :updateSceneInfo="updateSceneInfo"
          :updateSceneTree="updateSceneTree"
          :sceneData="originSceneData"
          :posEditInfo="currPosEditInfo"
          :exitPosEditMode="exitPosEditMode"
          :showDataSets="showDataSets"
          :hideDataSets="hideDataSets"
          :focusDataSets="focusDataSets"
          :focusEntities="focusEntities" />
      </div>
      <div class="engine-box">
        <div
          v-if="!sysUIPanelVisible && isDataSetLoadFinish"
          title="展开工具栏"
          class="collapse-box"
          @click="toggleSysUIPanelVisible">
          <i class="el-icon-arrow-up icon-rotate icon"></i>
          <!-- <icon-svg
            icon-class="icon-zhankai"
            class="icon" /> -->
        </div>
        <Engine ref="engine" />
        <ModelDataSetPanel
          ref="modelDataSetPanel"
          v-if="isModelDataSetVisible"
          :schemeType="currSchemeType"
          :currDataSetFolder="currDataSetFolder"
          :updateScene="updateScene"
          :updateSceneVector="updateSceneVector"
          :closeDataSetPanel="closeDataSetPanel" />
        <ElementPanel
          v-show="isElementPanelVisible"
          ref="entityPanel"
          :isPosEditMode="isPosEditMode"
          :currDataSetFolder="currDataSetFolder"
          :updateElemEditMode="updateElemEditMode"
          :updateCurrEditElem="updateCurrEditElem"
          :savePosition="savePosition"
          :preLoadElem="preLoadElem"
          :closeElementPanel="closeElementPanel" />
        <ExceptionDataDialog
          :visible="exceptionDataDialogVisible"
          :updateSceneTreeStatus="updateSceneTreeStatus"
          :updateSceneTree="updateSceneTree"
          :openConvertQueue="openConvertQueue"
          :closeDialog="closeExceptionDataDialog" />
        <ConvertQueueDialog
          :visible="isConvertQueueDialogVisible"
          :minimizeConvertQueue="minimizeConvertQueue"
          :closeDialog="closeConvertQueueDialog"
          :updateConvertDataSets="updateConvertDataSets" />
        <MiniConvertQueue
          ref="convertQueue"
          v-show="isMiniConvertQueueVisible"
          :maximizedConvertQueue="maximizedConvertQueue"
          :updateConvertDataSets="updateConvertDataSets"
          :closeConvertQueue="closeMiniConvertQueue" />
        <MoveToPanel
          v-if="isMoveToPanelVisible"
          ref="moveToPanel"
          :nodesToMove="nodesToMove"
          :closeMoveToPanel="closeMoveToPanel"
          :updateDataSetTree="updateSceneTree" />
        <PrioritySettingPanel
          v-if="isPrioritySettingPanelVisible"
          ref="prioritySetPanel"
          :gisInfo="gisInfo"
          :updateSceneTree="updateSceneTree"
          :updateUnitLayerLevelByLayerList="updateUnitLayerLevelByLayerList"
          :closePrioritySettingPanel="closePrioritySettingPanel" />
        <CadSettingPanel
          v-if="isCadSettingPanelVisible"
          ref="cadSetPanel"
          :cadInfo="currCadInfo"
          :updateUnitLayerLevelByLayerList="updateUnitLayerLevelByLayerList"
          :setUnitLODLevByDataSetId="setUnitLODLevByDataSetId"
          :openConvertQueue="openConvertQueue"
          :updateSceneTree="updateSceneTree"
          :updateSceneTreeStatus="updateSceneTreeStatus"
          :closeCADSettingPanel="closeCADSettingPanel" />
        <VectorSettingPanel
          v-if="isVectorSettingPanelVisible"
          ref="vectorSetPanel"
          :vectorInfo="currVectorInfo"
          :openConvertQueue="openConvertQueue"
          :updateConvertDataSets="updateConvertDataSets"
          :updateSceneTree="updateSceneTree"
          :updateSceneTreeStatus="updateSceneTreeStatus"
          :setUnitShpHole="setUnitShpHole"
          :updateUnitLayerLevelByLayerList="updateUnitLayerLevelByLayerList"
          :setUnitLODLevByDataSetId="setUnitLODLevByDataSetId"
          :closeVectorSettingPanel="closeVectorSettingPanel" />
        <AnimSetingPanel
          v-if="isAnimSettingPanelVisible"
          ref="animSetPanel"
          :closeAnimSettingPanel="closeAnimSettingPanel"
          :currEntity="currEntity" />
        <CreateWaterPanel
          v-if="isCreateWaterPanelVisible"
          ref="createWaterPanel"
          :currDataSetFolder="currDataSetFolder"
          :updateSceneTree="updateSceneTree"
          :expandNodeByDataSetType="expandNodeByDataSetType"
          :closeWaterPanel="closeCreateWaterPanel" />
        <EditWaterPanel
          v-if="isEditWaterPanelVisible"
          ref="editWaterPanel"
          :waterNodeInfo="waterNodeInfo"
          :updateSceneTree="updateSceneTree"
          :closeWaterPanel="closeEditWaterPanel" />
        <CreateExtrudePanel
          v-if="isCreateExtrudePanelVisible"
          ref="createExtrudePanel"
          :currDataSetFolder="currDataSetFolder"
          :findAllDataSets="findAllDataSets"
          :updateSceneTree="updateSceneTree"
          :expandNodeByDataSetType="expandNodeByDataSetType"
          :closeExtrudePanel="closeCreateExtrudePanel" />
        <EditExtrudePanel
          v-if="isEditExtrudePanelVisible"
          ref="editExtrudePanel"
          :extrudeNodeInfo="extrudeNodeInfo"
          :updateSceneTree="updateSceneTree"
          :findAllDataSets="findAllDataSets"
          :closeExtrudePanel="closeEditExtrudePanel" />
      </div>
      <div
        class="mouse-tip-box"
        v-show="mouseTipVisible"
        ref="mouseTip">
        <div v-if="currSchemeType === 'Entity'">
          点击左键添加构件，右键取消添加
        </div>
        <div>{{ mouseTipContent }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import SceneDataPanel from './components/SceneDataPanel.vue'
import SceneEditDataPanel from './components/SceneEditDataPanel.vue'
import Engine from '../../components/SceneViewEngine.vue'
import ModelDataSetPanel from './components/ModelDataSetPanel.vue'
import ElementPanel from './components/ElementPanel.vue'
import ExceptionDataDialog from './components/ExceptionDataDialog.vue'
import ConvertQueueDialog from './components/ConvertQueueDialog.vue'
import MiniConvertQueue from './components/MiniConvertQueue.vue'
import MoveToPanel from './components/MoveToPanel.vue'
import PrioritySettingPanel from './components/PrioritySettingPanel.vue'
import CadSettingPanel from './components/CadSettingPanel.vue'
import VectorSettingPanel from './components/VectorSettingPanel.vue'
import AnimSetingPanel from './components/AnimSetingPanel.vue'

import CreateWaterPanel from './water/components/CreateWaterPanel.vue'
import EditWaterPanel from './water/components/EditWaterPanel.vue'

import CreateExtrudePanel from './extrude/components/CreateExtrudePanel.vue'
import EditExtrudePanel from './extrude/components/EditExtrudePanel.vue'

import { Store } from '@/utils/store'

import { getTokenId } from '@/utils/generalMethods'

import {
  getSingleSceneTreeById,
  getDataSetResService,
  publicElemViewModelService,
  privateElemViewModelService,
  getExceptionListService,
  getGisPriorityListService,
  getExtrudeTexturesService
} from '@/service/interface'

const elemDataSetType = [17, 18]

export default {
  data() {
    return {
      isCollapse: false,
      originSceneData: [],
      currDataSetFolder: {},

      currSchemeType: '',
      isModelDataSetVisible: false,

      isConvertQueueDialogVisible: false,
      isMiniConvertQueueVisible: false,

      unloadFlag: false,
      convertSuccessDataSetIds: [],
      newAddedDataSets: [],

      exceptionDataDialogVisible: false,

      isMoveToPanelVisible: false,
      nodesToMove: {},

      isPrioritySettingPanelVisible: false,
      gisInfo: {},
      isCadSettingPanelVisible: false,
      currCadInfo: {},
      isVectorSettingPanelVisible: false,
      currVectorInfo: {},

      isElementPanelVisible: false,
      isPreLoadElemFlag: false,
      elemAddMode: '',
      currEditElem: {},
      currEntity: {},
      mouseTipVisible: false,
      mouseTipContent: '',

      isPosEditMode: false,
      currPosEditInfo: {},

      isAnimSettingPanelVisible: false,

      // 用于是否显示展开引擎工具栏按钮
      isDataSetLoadFinish: false,
      sysUIPanelVisible: false,

      isCreateWaterPanelVisible: false,
      isEditWaterPanelVisible: false,
      waterNodeInfo: {},

      isCreateExtrudePanelVisible: false,
      isEditExtrudePanelVisible: false,
      extrudeNodeInfo: {},

      // 当前打开的面板组件，用于多个面板间互斥功能开发
      currPanelRef: null
    }
  },
  props: {
    sceneInfo: Object,
    updateSceneInfo: Function,
    openPublishDialog: Function,
    openMoveToDialog: Function
  },
  components: {
    SceneDataPanel,
    SceneEditDataPanel,
    Engine,
    ModelDataSetPanel,
    ElementPanel,
    ExceptionDataDialog,
    ConvertQueueDialog,
    MiniConvertQueue,
    MoveToPanel,
    PrioritySettingPanel,
    CadSettingPanel,
    VectorSettingPanel,

    AnimSetingPanel,

    CreateWaterPanel,
    EditWaterPanel,

    CreateExtrudePanel,
    EditExtrudePanel
  },
  mounted() {
    this.$eventManage.on('engineCreated', this.onEngineCreated)
    this.$eventManage.on('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.on('themeChange', this.onUIThemeChange)
    this.$eventManage.on('customBtnClick', this.onCustomBtnClick)
    this.$eventManage.on('canvasMouseMove', this.onCanvasMouseMove)
    this.$eventManage.on('exitEntityEdit', this.onExitEntityEdit)
    this.$eventManage.on('selElement', this.handleModelClick)
    this.$eventManage.on('startEdit', this.startEditEntity)
    this.$eventManage.on('openAnimDialog', this.openAnimDialog)
  },
  beforeDestroy() {
    this.$eventManage.off('engineCreated', this.onEngineCreated)
    this.$eventManage.off('dataSetLoadFinish', this.onDataSetLoadFinish)
    this.$eventManage.off('themeChange', this.onUIThemeChange)
    this.$eventManage.off('customBtnClick', this.onCustomBtnClick)
    this.$eventManage.off('canvasMouseMove', this.onCanvasMouseMove)
    this.$eventManage.off('exitEntityEdit', this.onExitEntityEdit)
    this.$eventManage.off('selElement', this.handleModelClick)
    this.$eventManage.off('startEdit', this.startEditEntity)
    this.$eventManage.off('openAnimDialog', this.openAnimDialog)

    window.BlackHole3D.BIM.setSelMode(1)
    this.deleteCustomBtn('Close_SysUI')
  },
  methods: {
    onEngineCreated() {
      let timer = setInterval(() => {
        if (Object.keys(this.sceneInfo).length) {
          this.querySceneData().then(originSceneData => {
            this.originSceneData = originSceneData

            let domRef = this.$refs.engine
            if (this.sceneInfo.coordinates) {
              domRef.setEngineWorldCRS(this.sceneInfo.coordinates)
            }

            let dataSets = this.findAllDataSets()
            if (!dataSets.length) {
              domRef.loadDataSets([])
              return
            }

            this.getDataSetsResource(dataSets).then(dataSetsRes => {
              domRef.loadDataSets(dataSetsRes)
            })
          })

          clearInterval(timer)
        }
      }, 500)
    },
    onDataSetLoadFinish() {
      this.isDataSetLoadFinish = true
      // 防止添加或移除数据集时，引擎默认打开工具条出现的问题
      window.BlackHole3D.Graphics.setSysUIPanelVisible(this.sysUIPanelVisible)
      if (this.isPreLoadElemFlag) {
        this.isPreLoadElemFlag = false
        return
      }
      if (this.unloadFlag) {
        this.onDataSetUnLoadFinish()
        return
      }

      this.addCustomBtn()
      this.addEntities()
      this.setUnitShpHole()
      this.setUnitLayerLevel()
      this.setUnitLODLevRange()

      if (this.newAddedDataSets.length) {
        let dataSets = this.newAddedDataSets.map(el => el.dataSetId)
        let dataSetId = dataSets.pop()
        dataSetId = dataSetId.replaceAll('-', '')
        window.BlackHole3D.Camera.setCamLocateToDataSet(dataSetId, 1.0)

        this.newAddedDataSets = []
      }

      this.addWaters()
      // 初始化开挖纹理列表，避免多次调用服务端接口
      this.initExtrudeTextureList().then(() => {
        this.addExtrudes()
      })
    },
    addCustomBtn() {
      let domRef = this.$refs.engine

      // 关闭工具栏
      let closeLightImg = this.getImgPath('closeSysUILight.png')
      let closeStateList = []
      closeStateList.push({ hintText: '收起工具栏', texPath: closeLightImg })
      domRef.addCustomBtn('Close_SysUI', closeStateList, 0)
    },
    setUnitShpHole() {
      let allDataSets = this.findAllDataSets()
      let terrainDataSets = allDataSets.filter(el => el.srcDataSetType === 20)
      let terrainDataArray = []
      terrainDataSets.forEach(item => {
        let isDigHole = item.isDigHole
        let dataSetId = item.dataSetId.replaceAll('-', '')

        let dataSetIds = window.BlackHole3D.Model.getAllDataSetId()
        if (dataSetIds.includes(dataSetId)) {
          let obj = { dataSetId, isDigHole }
          terrainDataArray.push(obj)
        }
      })
      let domRef = this.$refs.engine
      terrainDataArray.forEach(item => {
        domRef.setUnitShpHole(item.dataSetId, item.isDigHole)
      })
    },
    setUnitShpHoleByDataSetId(dataSetId, isDigHole) {
      let domRef = this.$refs.engine
      dataSetId = dataSetId.replaceAll('-', '')
      domRef.setUnitShpHole(dataSetId, isDigHole)
    },
    setUnitLayerLevel() {
      const terrainType = [10, 13, 16, 20]
      let allDataSets = this.findAllDataSets()
      let terrainDataSets = allDataSets.filter(el =>
        terrainType.includes(el.srcDataSetType)
      )
      let terrainDataArray = []
      terrainDataSets.forEach(item => {
        let level = item.sortNum
        let dataSetId = item.dataSetId.replaceAll('-', '')

        let dataSetIds = window.BlackHole3D.Model.getAllDataSetId()
        if (dataSetIds.includes(dataSetId)) {
          let obj = { dataSetId, level }
          terrainDataArray.push(obj)
        }
      })
      let domRef = this.$refs.engine
      terrainDataArray.forEach(item => {
        domRef.setUnitLayerLevel(item.dataSetId, item.level)
      })
    },
    updateUnitLayerLevelByLayerList(layerList) {
      let newLayerList = JSON.parse(JSON.stringify(layerList))
      newLayerList = newLayerList.reverse()

      let domRef = this.$refs.engine
      let allDataSets = this.findAllDataSets()
      newLayerList.forEach((item, index) => {
        let find = allDataSets.find(el => el.nodeId === item.treeNodeId)
        let level = index + 1
        let dataSetId = find.dataSetId.replaceAll('-', '')
        domRef.setUnitLayerLevel(dataSetId, level)
      })
    },
    setUnitLODLevRange() {
      const terrainType = [16, 20]
      let allDataSets = this.findAllDataSets()
      let terrainDataSets = allDataSets.filter(item => {
        if (terrainType.includes(item.srcDataSetType)) {
          // 将不贴地展示的CAD过滤掉
          if (item.srcDataSetType === 16) {
            if (item.isTouchDown) {
              return true
            } else {
              return false
            }
          } else {
            return true
          }
        } else {
          return false
        }
      })

      let terrainDataArray = []
      terrainDataSets.map(item => {
        let systemLodConfig = item.systemLodConfig
        let maxLod = Number(systemLodConfig.lodNum) - 1
        let minLod = item.visibleDistance
        let dataSetId = item.dataSetId.replaceAll('-', '')

        let dataSetIds = window.BlackHole3D.Model.getAllDataSetId()
        if (dataSetIds.includes(dataSetId)) {
          let obj = { dataSetId, range: [minLod, maxLod] }
          terrainDataArray.push(obj)
        }
      })
      let domRef = this.$refs.engine
      terrainDataArray.forEach(item => {
        domRef.setUnitLODLevRange(item.dataSetId, item.range)
      })
    },
    setUnitLODLevByDataSetId(dataSetId, range) {
      let domRef = this.$refs.engine
      dataSetId = dataSetId.replaceAll('-', '')
      domRef.setUnitLODLevRange(dataSetId, range)
    },
    addEntities() {
      let allDataSets = this.findAllDataSets()
      let allEntities = allDataSets.filter(el =>
        elemDataSetType.includes(el.srcDataSetType)
      )

      if (allEntities.length) {
        const BlackHole3D = window.BlackHole3D
        BlackHole3D.Entity.enterEditMode()
        let entityList = []
        allEntities.forEach(item => {
          let dataSetId = item.srcDataSetId
          let resId = dataSetId.replaceAll('-', '')
          let typeNames = BlackHole3D.Entity.getAllTypeNames(resId)
          let componentInfo = item.componentInfo
          let location = componentInfo.location

          let entity = new BlackHole3D.REEntityInfo()
          entity.dataSetId = resId
          entity.entityType = typeNames[0]
          entity.elemId = item.elemId
          entity.scale = JSON.parse(location.scale)
          entity.rotate = JSON.parse(location.rotate)
          entity.offset = JSON.parse(location.translation)
          entityList.push(entity)
        })
        BlackHole3D.Entity.addEntities(entityList)
        BlackHole3D.Entity.exitEditMode()

        const AnimPlayModeEm = BlackHole3D.REEntityAnimPlayModeEm
        const AnimPlayStateEm = BlackHole3D.REEntityAnimPlayStateEm
        allEntities.forEach(item => {
          let dataSetId = item.dataSetId
          let resId = dataSetId.replaceAll('-', '')
          let typeNames = BlackHole3D.Entity.getAllTypeNames(resId)

          let componentInfo = item.componentInfo
          let playMode = componentInfo.playMode
          let animPlayInfo = new BlackHole3D.REEntityAnimPlayInfo()
          animPlayInfo.dataSetId = resId
          animPlayInfo.entityType = typeNames[0]
          animPlayInfo.elemIdList = [item.elemId]
          animPlayInfo.animPlayMode = AnimPlayModeEm[playMode]
          if (item.enableAnimationPlay) {
            animPlayInfo.animPlayState = AnimPlayStateEm.PLAY
          } else {
            animPlayInfo.animPlayState = AnimPlayStateEm.PAUSE
          }
          BlackHole3D.Entity.setAnimPlayMode(animPlayInfo)
        })
      }
    },
    addWaters() {
      let allLeafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let allWaters = allLeafNodes.filter(item => item.dataSetType == 23)

      let waterList = []
      const BlackHole3D = window.BlackHole3D
      allWaters.forEach(item => {
        let waterInfo = item.waterInfo
        let waterGeoJson = JSON.parse(waterInfo.geoJson)

        let rgnList = waterGeoJson.rgnList
        let rgnInfo = rgnList[0]
        let cornerRgnInfo = new BlackHole3D.RECornerRgnInfo()
        cornerRgnInfo.pointList = rgnInfo.pointList
        cornerRgnInfo.indexList = rgnInfo.indexList

        let waterRgnList = [cornerRgnInfo]
        let { red, green, blue, alpha } = waterGeoJson.waterClr
        let waterClr = new BlackHole3D.REColor(red, green, blue, alpha)
        let waterInstance = new BlackHole3D.REWaterInfo()
        waterInstance.waterName = waterInfo.id
        waterInstance.waterClr = waterClr
        waterInstance.blendDist = waterGeoJson.blendDist
        waterInstance.visible = waterGeoJson.visible
        waterInstance.expandDist = waterGeoJson.expandDist
        waterInstance.depthBias = waterGeoJson.depthBias
        waterInstance.visDist = waterGeoJson.visDist
        waterInstance.rgnList = waterRgnList

        waterList.push(waterInstance)
      })

      if (waterList.length) {
        BlackHole3D.Water.setData(waterList)
      }
    },
    addExtrudes() {
      let allLeafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let allExtrudes = allLeafNodes.filter(item => item.dataSetType == 24)

      let extrudeList = []
      let textureList = Store.extrudeTextureList
      const BlackHole3D = window.BlackHole3D
      allExtrudes.forEach(item => {
        let extrudeInfo = item.excavateInfo
        let extrudeGeoJson = JSON.parse(extrudeInfo.geoJson)

        let rgnList = extrudeGeoJson.rgnList
        let extrudeInstance = new BlackHole3D.REExtrudeInfo()
        extrudeInstance.extrudeId = extrudeInfo.id
        extrudeInstance.dataSetIdList = extrudeGeoJson.dataSetIdList
        extrudeInstance.rgnList = rgnList
        extrudeInstance.depthLimitRange = extrudeGeoJson.depthLimitRange
        extrudeInstance.type = extrudeGeoJson.type
        if (extrudeGeoJson.type === 2) {
          let find = textureList.find(
            el => el.textureGuid === extrudeInfo.textureFileDataId
          )
          extrudeInstance.texId = find.textureId
        }

        extrudeList.push(extrudeInstance)
      })

      if (extrudeList.length) {
        BlackHole3D.Extrude.setData(extrudeList)
      }
    },
    onExitEntityEdit() {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Probe.setProbeMode(0)
      BlackHole3D.Entity.exitEditMode()

      this.mouseTipVisible = false
      this.entityAddMode = ''
    },
    handleModelClick(eventInfo) {
      if (this.isPosEditMode) return
      // 防止创建或编辑水面时高亮构件
      // prettier-ignore
      if (this.isEditWaterPanelVisible || this.isCreateWaterPanelVisible) return;
      // prettier-ignore
      if (this.isEditExtrudePanelVisible || this.isCreateExtrudePanelVisible) return;
      let elemInfo = eventInfo.elemInfo

      const BlackHole3D = window.BlackHole3D
      if (this.isPosEditMode) {
        // 防止在控制点配准模式下，选择集错乱导致出现异常情况，因此增加以下代码，后续引擎异常情况解决后，删除此处代码，直接return即可
        let dataSetId = elemInfo.dataSetId
        if (!dataSetId) {
          BlackHole3D.BIM.delAllSelDateSets()
          return
        }

        if (!BlackHole3D.Edit.getDataSetEditEnable(dataSetId)) {
          BlackHole3D.BIM.delFromSelDateSets([dataSetId])
        }
        return
      }

      BlackHole3D.BIM.delAllSelElems()
      BlackHole3D.BIM.setSelMode(1)

      // 防止添加构件时，模型的构件会高亮
      if (this.elemAddMode !== '') return

      if (this.isEntityElem(elemInfo)) {
        this.handleEntityElemClick(elemInfo)
      } else {
        if (elemInfo.dataSetId) {
          BlackHole3D.BIM.addToSelElems(elemInfo.dataSetId, [elemInfo.elemId])
        }

        this.hiddenBVShp()
        this.$nextTick(() => {
          let domRef = this.$refs.sceneDataPanel
          domRef.setCurrentKey(null)
        })
      }
    },
    handleEntityElemClick(elemInfo) {
      let allDataSets = this.findAllDataSets()
      let allEntityElems = allDataSets.filter(el =>
        elemDataSetType.includes(el.srcDataSetType)
      )

      let find = allEntityElems.find(item => {
        let dataSetId = item.srcDataSetId
        let resId = dataSetId.replaceAll('-', '')
        if (resId === elemInfo.dataSetId && item.elemId === elemInfo.elemId) {
          return true
        } else {
          return false
        }
      })

      if (find) {
        this.currEntity = find
        let dataSetId = find.srcDataSetId.replaceAll('-', '')

        let entities = [
          {
            dataSetId,
            elemIds: [find.elemId]
          }
        ]
        this.highLightEntities(entities, false)
        this.showBVShp(dataSetId, find.elemId)
        this.$nextTick(() => {
          let domRef = this.$refs.sceneDataPanel
          domRef.setCurrentKey(find.nodeId)
        })
      } else {
        this.hiddenBVShp()
        this.$nextTick(() => {
          let domRef = this.$refs.sceneDataPanel
          domRef.setCurrentKey(null)
        })
      }
    },
    updateElemEditMode(elemAddMode) {
      this.elemAddMode = elemAddMode
    },
    updateCurrEditElem(elemInfo) {
      this.currEditElem = elemInfo
    },
    updateCurrEntity(currEntity) {
      this.currEntity = currEntity
    },
    startEditEntity() {
      let entityInfo = this.currEntity

      let domRef = this.$refs.sceneDataPanel
      let expandNodeKeys = domRef.getExpandNodeKeys()
      let posEditInfo = {
        dataSetType: entityInfo.dataSetType,
        expandNodeKeys,
        selectedDataSets: [entityInfo]
      }

      this.enterPosEditMode(posEditInfo)
    },
    enterPosEditMode(posEditInfo) {
      const BlackHole3D = window.BlackHole3D
      let isEntityEditMode = BlackHole3D.Entity.getEditMode()
      if (isEntityEditMode) {
        this.$message.warning('当前正处于构件添加状态，请结束添加后再编辑位置')
        return
      }

      let isClipState = BlackHole3D.Clip.getClipState()
      if (isClipState) {
        this.$message.warning('当前正处于剖切状态，请退出剖切后再编辑位置')
        return
      }

      this.hiddenBVShp()
      this.currPosEditInfo = posEditInfo

      this.$nextTick(() => {
        let domRef = this.$refs.scenePosEditDataPanel
        domRef.initEdit()
        // 延迟打开编辑目录树面板，防止出现目录树展开动画
        setTimeout(() => {
          this.isPosEditMode = true

          this.sysUIPanelVisible = false
          BlackHole3D.Graphics.setSysUIPanelVisible(false)
        }, 10)
      })
    },
    exitPosEditMode() {
      this.isPosEditMode = false
      this.currPosEditInfo = {}

      this.showAllData()

      this.$nextTick(() => {
        let domRef = this.$refs.scenePosEditDataPanel
        domRef.resetSceneData()
      })
    },
    // 退出编辑时恢复显示所有数据
    showAllData() {
      let allDataSets = this.findAllDataSets()

      let dataSetIds = []
      let dataSets = allDataSets.map(item => {
        let dataSetId = ''
        if (elemDataSetType.includes(item.srcDataSetType)) {
          dataSetId = item.srcDataSetId.replaceAll('-', '')
        } else {
          dataSetId = item.dataSetId.replaceAll('-', '')
        }
        dataSetIds.push(dataSetId)

        let obj = {
          dataSetId,
          dataSetType: item.srcDataSetType,
          elemId: item.elemId
        }
        return obj
      })
      if (this.$refs.engine) {
        this.showDataSets(dataSets)
      }

      // 解除所有数据集的禁用编辑状态
      window.BlackHole3D.Edit.setDataSetEditEnable(dataSetIds, true)
    },
    showBVShp(dataSetId, elemId) {
      const BlackHole3D = window.BlackHole3D
      BlackHole3D.Anchor.delAllAnc()
      BlackHole3D.Entity.setBVShpVisiable(true)
      BlackHole3D.Entity.setBVShpRange(dataSetId, [elemId])

      let bvInfo = BlackHole3D.BIM.getElemTotalBV(dataSetId, [elemId])
      let xCenter = Number(((bvInfo[0] + bvInfo[1]) / 2).toFixed(6))
      let yCenter = Number(((bvInfo[2] + bvInfo[3]) / 2).toFixed(6))
      let zCenter = Number(((bvInfo[4] + bvInfo[5]) / 2).toFixed(6))
      this.addAnchors(xCenter, yCenter, zCenter)
    },
    hiddenBVShp() {
      if (!Object.keys(this.currEntity).length) return
      const BlackHole3D = window.BlackHole3D
      let dataSetId = this.currEntity.dataSetId
      dataSetId = dataSetId.replaceAll('-', '')
      let elemId = this.currEntity.elemId
      BlackHole3D.Anchor.delAllAnc()
      BlackHole3D.Entity.setBVShpRange(dataSetId, [elemId])
      BlackHole3D.Entity.setBVShpVisiable(false)

      this.currEntity = {}
    },
    savePosition() {
      return new Promise(resolve => {
        let domRef = this.$refs.scenePosEditDataPanel
        domRef.savePosition().then(() => {
          window.BlackHole3D.Edit.endEdit()
          window.BlackHole3D.BIM.setSelMode(1)

          this.exitPosEditMode()
          resolve()
        })
      })
    },
    preLoadElem(dataSets) {
      this.queryDataSetRes(dataSets).then(dataSetsRes => {
        this.isPreLoadElemFlag = true

        let domRef = this.$refs.engine
        domRef.loadDataSets(dataSetsRes, false)
      })
    },
    onCanvasMouseMove(eventInfo) {
      let { coorInfo } = eventInfo
      let { clientX, clientY, visible, tipContent } = coorInfo
      this.mouseTipVisible = visible
      this.mouseTipContent = tipContent

      this.$refs.mouseTip.style.top = clientY + 'px'
      this.$refs.mouseTip.style.left = clientX + 'px'
    },
    updateCurrDataSetFolder(currDataSetFolder) {
      this.currDataSetFolder = currDataSetFolder
    },
    updateScene(dataSets) {
      this.newAddedDataSets = dataSets

      this.updateSceneTree()

      this.getDataSetsResource(dataSets).then(dataSetsRes => {
        let domRef = this.$refs.engine
        domRef.loadDataSets(dataSetsRes, false)
      })
    },
    // 添加矢量瓦片和CAD瓦片
    updateSceneVector(dataSetType) {
      this.updateSceneTree().then(() => {
        this.expandNodeByDataSetType(dataSetType)
      })
      this.openConvertQueue()
    },
    updateSceneTree() {
      return new Promise(resolve => {
        this.querySceneData().then(originSceneData => {
          this.originSceneData = originSceneData

          let domRef = this.$refs.sceneDataPanel
          if (domRef) {
            domRef.setExpandNodes()
            domRef.setCheckedNodes()
          }

          let modelDataDomRef = this.$refs.modelDataSetPanel
          if (modelDataDomRef) {
            modelDataDomRef.updateData()
          }

          resolve()
        })
      })
    },
    expandNodeByDataSetType(dataSetType) {
      let domRef = this.$refs.sceneDataPanel
      if (domRef) {
        domRef.expandNodeByDataSetType(dataSetType)
      }
    },
    updateConvertDataSets(dataSetIds) {
      this.updateSceneTreeByDataSetIds(dataSetIds).then(() => {
        let isAllUnloaded = true

        dataSetIds.forEach(item => {
          let originData = this.originSceneData
          let dataSetInfo = this.findNodeByDataSetId(originData, item)

          if (dataSetInfo.status === 5) {
            let find = this.convertSuccessDataSetIds.find(el => el === item)
            if (!find) {
              this.convertSuccessDataSetIds.push(item)
            }

            let dataSetId = item.replaceAll('-', '')
            let loadedDataSetIds = window.BlackHole3D.Model.getAllDataSetId()
            if (loadedDataSetIds.includes(dataSetId)) {
              isAllUnloaded = false
              this.unloadFlag = true
              let domRef = this.$refs.engine
              domRef.unloadDataSets([dataSetId])
            }
          }
        })

        if (isAllUnloaded) {
          this.onDataSetUnLoadFinish()
        }
      })
    },
    onDataSetUnLoadFinish() {
      setTimeout(() => {
        let dataSetIds = this.convertSuccessDataSetIds
        let dataSets = []
        dataSetIds.forEach(item => {
          let dataSet = this.findNodeByDataSetId(this.originSceneData, item)
          dataSets.push(dataSet)
          this.newAddedDataSets.push(dataSet)
        })

        this.getDataSetsResource(dataSets).then(dataSetsRes => {
          if (dataSets.length) {
            this.unloadFlag = false

            let domRef = this.$refs.engine
            domRef.loadDataSets(dataSetsRes, false)

            this.convertSuccessDataSetIds = []
          }
        })
      }, 500)
    },
    updateSceneTreeByDataSetIds(dataSetIds) {
      return new Promise(resolve => {
        this.querySceneData().then(originSceneData => {
          dataSetIds.forEach(item => {
            let originData = this.findNodeByDataSetId(
              this.originSceneData,
              item
            )
            let newData = this.findNodeByDataSetId(originSceneData, item)
            originData.status = newData.status
            originData.viewStatus = newData.viewStatus
            originData.hasUpdated = newData.hasUpdated
            originData.isTouchDown = newData.isTouchDown
            originData.systemLodConfig = newData.systemLodConfig
          })
          resolve()
        })
      })
    },
    updateSceneTreeStatus(dataSetIds) {
      if (dataSetIds && dataSetIds.length) {
        dataSetIds.forEach(item => {
          let originData = this.findNodeByDataSetId(this.originSceneData, item)
          originData.status = 2
          originData.viewStatus = 2
        })
      } else {
        let allDataSets = this.findAllDataSets()
        allDataSets = allDataSets.filter(
          el => !elemDataSetType.includes(el.srcDataSetType) && el.hasUpdated
        )
        allDataSets.forEach(item => {
          let originData = this.findNodeByDataSetId(
            this.originSceneData,
            item.dataSetId
          )
          originData.status = 2
          originData.viewStatus = 2
        })
      }
    },
    // 打开面板前关闭其他面板
    openPanelCheck() {
      return new Promise(resolve => {
        let domRef = this.currPanelRef
        if (!domRef) {
          resolve()
          return
        }

        domRef.openOtherPanelCheck().then(isCheckPass => {
          if (isCheckPass) {
            this.currPanelRef = null
            resolve()
          }
        })
      })
    },
    openDataSetPanel(schemeType) {
      this.openPanelCheck().then(() => {
        if (this.currSchemeType && schemeType !== this.currSchemeType) {
          this.currDataSetFolder = {}
        }
        this.currSchemeType = schemeType
        this.isModelDataSetVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.modelDataSetPanel
        })
      })
    },
    closeDataSetPanel() {
      this.currSchemeType = ''
      this.isModelDataSetVisible = false

      this.currPanelRef = null
    },
    openElementPanel() {
      this.openPanelCheck().then(() => {
        if (this.currSchemeType && 'Entity' !== this.currSchemeType) {
          this.currDataSetFolder = {}
        }
        this.closeDataSetPanel()
        this.currSchemeType = 'Entity'
        this.isElementPanelVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.entityPanel
        })
      })
    },
    closeElementPanel() {
      this.currSchemeType = ''
      this.isElementPanelVisible = false

      this.currPanelRef = null
    },
    openAnimDialog(eventInfo) {
      let { visible } = eventInfo
      if (visible) {
        this.openPanelCheck().then(() => {
          this.isAnimSettingPanelVisible = true

          this.$nextTick(() => {
            this.currPanelRef = this.$refs.animSetPanel
          })
        })
      }
    },
    closeAnimSettingPanel() {
      this.isAnimSettingPanelVisible = false

      this.currPanelRef = null
    },
    openCreateWaterPanel() {
      this.openPanelCheck().then(() => {
        this.currSchemeType = 'Water'
        this.isCreateWaterPanelVisible = true

        if (!this.sysUIPanelVisible) {
          this.sysUIPanelVisible = true
        } else {
          window.BlackHole3D.Graphics.setSysUIPanelVisible(false)
        }

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.createWaterPanel
        })
      })
    },
    closeCreateWaterPanel() {
      this.currSchemeType = ''
      this.isCreateWaterPanelVisible = false

      if (this.sysUIPanelVisible) {
        this.sysUIPanelVisible = false
      }

      this.currPanelRef = null
    },
    openEditWaterPanel(waterNodeInfo) {
      this.openPanelCheck().then(() => {
        this.waterNodeInfo = waterNodeInfo
        this.isEditWaterPanelVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.editWaterPanel
        })
      })
    },
    closeEditWaterPanel() {
      this.waterNodeInfo = {}
      this.isEditWaterPanelVisible = false

      this.currPanelRef = null
    },
    openCreateExtrudePanel() {
      this.openPanelCheck().then(() => {
        this.currSchemeType = 'Extrude'
        this.isCreateExtrudePanelVisible = true

        if (!this.sysUIPanelVisible) {
          this.sysUIPanelVisible = true
        } else {
          window.BlackHole3D.Graphics.setSysUIPanelVisible(false)
        }

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.createExtrudePanel
        })
      })
    },
    closeCreateExtrudePanel() {
      this.currSchemeType = ''
      this.isCreateExtrudePanelVisible = false

      if (this.sysUIPanelVisible) {
        this.sysUIPanelVisible = false
      }

      this.currPanelRef = null
    },
    openEditExtrudePanel(extrudeNodeInfo) {
      this.openPanelCheck().then(() => {
        this.extrudeNodeInfo = extrudeNodeInfo
        this.isEditExtrudePanelVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.editExtrudePanel
        })
      })
    },
    closeEditExtrudePanel() {
      this.extrudeNodeInfo = {}
      this.isEditExtrudePanelVisible = false

      this.currPanelRef = null
    },
    openConvertQueueDialog() {
      if (this.isMiniConvertQueueVisible) {
        this.isMiniConvertQueueVisible = false
      }
      this.isConvertQueueDialogVisible = true
    },
    minimizeConvertQueue() {
      this.isConvertQueueDialogVisible = false
      this.isMiniConvertQueueVisible = true
    },
    maximizedConvertQueue() {
      this.isConvertQueueDialogVisible = true
      this.isMiniConvertQueueVisible = false
    },
    closeConvertQueueDialog() {
      this.isConvertQueueDialogVisible = false
    },
    initPosition() {
      let domRef = this.$refs.scenePosEditDataPanel
      domRef.initPosition()
    },
    openConvertQueue() {
      setTimeout(() => {
        this.$refs.convertQueue.initQueueList()
        this.isMiniConvertQueueVisible = true
      }, 1000)
    },
    closeMiniConvertQueue() {
      this.isMiniConvertQueueVisible = false
    },
    toggleExceptionData() {
      this.exceptionDataDialogVisible = !this.exceptionDataDialogVisible
    },
    closeExceptionDataDialog() {
      this.exceptionDataDialogVisible = false
    },
    openMoveToPanel(nodesData) {
      this.openPanelCheck().then(() => {
        this.nodesToMove = nodesData
        this.isMoveToPanelVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.moveToPanel
        })
      })
    },
    closeMoveToPanel() {
      this.nodesToMove = {}
      this.isMoveToPanelVisible = false

      this.currPanelRef = null
    },
    openPrioritySettingPanel(gisInfo) {
      this.openPanelCheck().then(() => {
        let nodeId = gisInfo.sceneNodeId
        getGisPriorityListService(nodeId).then(response => {
          if (response.isSuccess) {
            let priorityList = response.data
            if (priorityList.length) {
              this.gisInfo = gisInfo
              this.isPrioritySettingPanelVisible = true

              this.$nextTick(() => {
                this.currPanelRef = this.$refs.prioritySetPanel
              })
            } else {
              let warningMsg = '当前只有一个WMTS或遥感影像，无需设置优先级'
              this.$message.warning(warningMsg)
            }
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    closePrioritySettingPanel() {
      this.gisInfo = {}
      this.isPrioritySettingPanelVisible = false

      this.currPanelRef = null
    },
    openCADSettingPanel(cadInfo) {
      this.openPanelCheck().then(() => {
        this.currCadInfo = cadInfo
        this.isCadSettingPanelVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.cadSetPanel
        })
      })
    },
    closeCADSettingPanel() {
      this.currCadInfo = {}
      this.isCadSettingPanelVisible = false

      this.currPanelRef = null
    },
    openVectorSettingPanel(vectorInfo) {
      this.openPanelCheck().then(() => {
        this.currVectorInfo = vectorInfo
        this.isVectorSettingPanelVisible = true

        this.$nextTick(() => {
          this.currPanelRef = this.$refs.vectorSetPanel
        })
      })
    },
    closeVectorSettingPanel() {
      this.currVectorInfo = {}
      this.isVectorSettingPanelVisible = false

      this.currPanelRef = null
    },
    toggleCollapsePanel() {
      this.isCollapse = !this.isCollapse
      this.$nextTick(() => {
        this.$refs.engine.setCanvasSize()
      })
    },
    toggleSysUIPanelVisible() {
      const BlackHole3D = window.BlackHole3D
      if (this.isPosEditMode) {
        let warningMsg = '当前正处于位置编辑状态，请编辑结束后再执行工具栏操作'
        this.$message.warning(warningMsg)
        return
      }

      this.sysUIPanelVisible = !this.sysUIPanelVisible
      BlackHole3D.Graphics.setSysUIPanelVisible(this.sysUIPanelVisible)
    },
    publishCheck() {
      return new Promise(resolve => {
        this.exitCheck().then(result => {
          if (!result) return

          let sceneId = this.$route.query.sceneId
          let params = { sceneId }
          getExceptionListService({ params }).then(response => {
            if (response.isSuccess) {
              let data = response.data
              let exceptionList = data.items
              if (exceptionList.length) {
                let warningMsg = '场景中存在异常数据，请处理完异常数据后再发布'
                this.$message.warning(warningMsg)
                resolve(false)
              } else {
                let dataSets = this.findAllNodeByLevel(this.originSceneData, 2)
                let modelDataSets = dataSets.filter(
                  el => !elemDataSetType.includes(el.srcDataSetType)
                )
                let updateDataSets = modelDataSets.filter(el => el.hasUpdated)
                if (updateDataSets.length) {
                  this.openPublishDialog(updateDataSets)
                  resolve(false)
                } else {
                  resolve(true)
                }
              }
            }
          })
        })
      })
    },
    getBBoxParams() {
      let dataSets = this.findAllNodeByLevel(this.originSceneData, 2)
      dataSets = dataSets.filter(el => el.dataSetType !== 10)
      let nodeBBoxes = []
      const BlackHole3D = window.BlackHole3D
      dataSets.forEach(item => {
        let obj = {
          nodeId: item.nodeId
        }
        if (item.dataSetType === 0) {
          let dataSetId = item.dataSetId.replaceAll('-', '')
          let bbox = BlackHole3D.BIM.getTotalBV(dataSetId)
          bbox = [bbox[0], bbox[2], bbox[4], bbox[1], bbox[3], bbox[5]]
          obj.bbox = bbox.join(',')
        }

        if (elemDataSetType.includes(item.srcDataSetType)) {
          let dataSetId = item.srcDataSetId.replaceAll('-', '')
          let bbox = BlackHole3D.BIM.getElemTotalBV(dataSetId, [item.elemId])
          bbox = [bbox[0], bbox[2], bbox[4], bbox[1], bbox[3], bbox[5]]
          obj.bbox = bbox.join(',')
        }

        // prettier-ignore
        if (item.dataSetType !== 0 && !elemDataSetType.includes(item.srcDataSetType)) {
          let dataSetId = item.dataSetId.replaceAll("-", "");
          let bbox = BlackHole3D.Grid.getDataSetBV(dataSetId);
          bbox = [bbox[0], bbox[2], bbox[4], bbox[1], bbox[3], bbox[5]];
          obj.bbox = bbox.join(",");
        }

        nodeBBoxes.push(obj)
      })

      return nodeBBoxes
    },
    exitCheck() {
      return new Promise(resolve => {
        const BlackHole3D = window.BlackHole3D

        let editMode = BlackHole3D.Entity.getEditMode()
        if (editMode) {
          this.$confirm('当前正在添加构件，是否退出', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
            .then(() => {
              BlackHole3D.Entity.exitEditMode()

              this.mouseTipVisible = false
              this.entityAddMode = ''
              this.$message.info('退出添加')
              resolve(true)
            })
            .catch(() => {
              this.$message.info('取消退出')
              resolve(false)
            })
          return
        }

        if (this.isPosEditMode) {
          this.$confirm(
            '当前正处于位置编辑状态，是否退出并保存当前位置信息',
            '提示',
            {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.savePosition().then(() => {
                resolve(true)
              })
            })
            .catch(() => {
              this.$message.info('取消退出')
              resolve(false)
            })
          return
        }

        this.openPanelCheck().then(() => {
          resolve(true)
        })
      })
    },
    onUIThemeChange(eventInfo) {
      let themeName = eventInfo.themeName

      let Graphics = window.BlackHole3D.Graphics
      if (themeName.includes('Light')) {
        let treeLightImg = this.getImgPath('closeSysUILight.png')
        Graphics.setBtnStatePicPath('Close_SysUI', 0, treeLightImg)
        Graphics.setSysPanelBtnClrStyle('Close_SysUI', 0)
      }

      if (themeName.includes('Dark')) {
        let treeDarkImg = this.getImgPath('closeSysUIDark.png')
        Graphics.setBtnStatePicPath('Close_SysUI', 0, treeDarkImg)
        Graphics.setSysPanelBtnClrStyle('Close_SysUI', 1)
      }
    },
    onCustomBtnClick(eventInfo) {
      let btnName = eventInfo.btnName
      if (btnName.includes('Close_SysUI')) {
        this.toggleSysUIPanelVisible()
      }
    },
    getDataSetsResource(dataSets) {
      return new Promise(resolve => {
        this.queryDataSetRes(dataSets).then(dataSetsRes => {
          let { dataSetPosition } = this.sceneInfo
          const terrainType = [21, 22]
          dataSetsRes.forEach(item => {
            if (terrainType.includes(item.dataSetType)) {
              let find = dataSets.find(el => el.dataSetId === item.dataSetId)
              item.isTouchDown = find.isTouchDown
            }

            let findPos = dataSetPosition.find(
              el => el.dataSetId === item.dataSetId
            )
            if (findPos) {
              if (terrainType.includes(item.dataSetType)) {
                let findDataSet = dataSets.find(
                  el => el.dataSetId === item.dataSetId
                )
                if (!findDataSet.isTouchDown) {
                  item.rotate = findPos.rotate
                  item.scale = findPos.scale
                  item.translation = findPos.translation
                }
              } else {
                item.rotate = findPos.rotate
                item.scale = findPos.scale
                item.translation = findPos.translation
              }
            }
          })

          resolve(dataSetsRes)
        })
      })
    },
    queryDataSetRes(dataSets) {
      return new Promise(resolve => {
        let normalDataSetIds = []
        let publicDataSetIds = []
        let privateDataSetIds = []

        dataSets.forEach(item => {
          let dataSetType = item.srcDataSetType
          if (dataSetType === 17) {
            let find = publicDataSetIds.find(el => el === item.srcDataSetId)
            if (!find) {
              publicDataSetIds.push(item.srcDataSetId)
            }
          } else if (dataSetType === 18) {
            let find = privateDataSetIds.find(el => el === item.srcDataSetId)
            if (!find) {
              privateDataSetIds.push(item.srcDataSetId)
            }
          } else {
            normalDataSetIds.push(item.dataSetId)
          }
        })

        let promiseArray = []
        if (normalDataSetIds.length) {
          let params = { dataSetIds: normalDataSetIds }
          promiseArray.push(getDataSetResService(params))
        }
        if (publicDataSetIds.length) {
          let params = { dataSetIds: publicDataSetIds }
          promiseArray.push(publicElemViewModelService(params))
        }
        if (privateDataSetIds.length) {
          let params = { dataSetIds: privateDataSetIds }
          promiseArray.push(privateElemViewModelService(params))
        }
        Promise.all(promiseArray).then(resultArray => {
          let dataSetRes = []
          resultArray.forEach(item => {
            if (item.isSuccess) {
              dataSetRes = [...item.data, ...dataSetRes]
            }
          })
          resolve(dataSetRes)
        })
      })
    },
    querySceneData() {
      return new Promise(resolve => {
        let sceneId = this.$route.query.sceneId
        getSingleSceneTreeById({ sceneId }).then(response => {
          if (response.isSuccess) {
            let data = response.data
            let sceneData = this.formatSceneData(data)
            resolve(sceneData)
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    formatSceneData(data) {
      if (!data) return []
      let sceneData = data
      let rootFolders = this.findAllNodeByLevel(sceneData, 3)
      rootFolders.forEach(item => {
        if (item.dataSetType === 0) {
          item['sceneNodeName'] = 'BIM'
          item['nodeName'] = 'BIM'
          item['levelPathName'] = 'BIM'
        }
        if (item.dataSetType === 10) {
          item['sceneNodeName'] = 'WMTS'
          item['nodeName'] = 'WMTS'
          item['levelPathName'] = 'WMTS'
        }
      })
      let folders = this.findAllNodeByLevel(sceneData, 1)
      let allFolders = [...rootFolders, ...folders]
      allFolders.forEach(item => {
        let rootNodeId = item.levelCode.split('/')[0]
        let find = rootFolders.find(el => el.sceneNodeId === rootNodeId)
        item.dataSetType = find.dataSetType
        item.srcDataSetType = find.srcDataSetType
        item['nodeName'] = item.sceneNodeName
        item['nodeId'] = item.sceneNodeId
      })

      let allDatasets = this.findAllNodeByLevel(sceneData, 2)
      let { componentPosition } = this.sceneInfo
      allDatasets.forEach(item => {
        if (item.dataSetType === 0) {
          item['levelPathName'] = item.levelPathName.replace('模型/', 'BIM/')
          item['levelPathName'] = item.levelPathName.replace('模型/', 'BIM/')
        }
        if (item.dataSetType === 10) {
          item['levelPathName'] = item.levelPathName.replace('wmts/', 'WMTS/')
        }

        let findLastIndex = item.sceneNodeName.lastIndexOf('.')
        if (findLastIndex !== -1) {
          item['nodeName'] = item.sceneNodeName.substring(0, findLastIndex)
          item['sceneNodeName'] = item.nodeName
        } else {
          item['nodeName'] = item.sceneNodeName
        }
        item['nodeId'] = item.sceneNodeId

        if (elemDataSetType.includes(item.srcDataSetType)) {
          let componentInfo = item.componentInfo
          // 构件id需要经常使用，因此将其从构件信息中提取出来
          componentInfo.id = componentInfo.treeNodeId
          componentInfo.elemId = componentInfo.instanceIndex
          item.elemId = componentInfo.instanceIndex

          let find = componentPosition.find(el => el.id === componentInfo.id)
          if (find) {
            componentInfo.location = {
              rotate: find.rotate,
              scale: find.scale,
              translation: find.translation
            }
          }
        }

        // 水面类型，将waterId提升一级，方便调用
        if (item.dataSetType === 23) {
          let waterInfo = item.waterInfo
          item.waterId = waterInfo.id
        }

        // 开挖类型，将extrudeId提升一级，方便调用
        if (item.dataSetType === 24) {
          let extrudeInfo = item.excavateInfo
          item.extrudeId = extrudeInfo.id
        }
      })

      return sceneData
    },
    initExtrudeTextureList() {
      return new Promise(resolve => {
        let textureList = Store.extrudeTextureList
        if (textureList.length) {
          resolve()
          return
        }

        getExtrudeTexturesService().then(response => {
          if (response.isSuccess) {
            let data = response.data
            let intrinsicTextures = data.intrinsicTextures

            if (intrinsicTextures && intrinsicTextures.length) {
              const Extrude = window.BlackHole3D.Extrude
              textureList = intrinsicTextures.map(item => {
                let picPath = ''
                let tokenId = getTokenId()
                let timestamp = new Date().getTime()
                if (window.downloadUrl.includes('http')) {
                  picPath = `${window.downloadUrl}/${item.fileDataId}?token=${tokenId}&timestamp=${timestamp}`
                } else {
                  picPath = `${window.serverUrl}/${window.downloadUrl}/${item.fileDataId}?token=${tokenId}&timestamp=${timestamp}`
                }
                let size = [5.0, 5.0]
                let textureId = Extrude.addExtrudeFaceTex(picPath, size)

                let obj = {
                  textureId,
                  textureGuid: item.TextureImageId,
                  texturePicPath: picPath
                }
                return obj
              })
            }

            Store.extrudeTextureList = textureList
            resolve()
          } else {
            this.$message.error(response.errMsg)
          }
        })
      })
    },
    findAllDataSets() {
      // 在场景中需要依赖资源包才能展示的数据类型
      const dependentResourceTypes = [0, 10, 11, 13, 15, 16, 19, 21, 22]

      let allLeafNodes = this.findAllNodeByLevel(this.originSceneData, 2)
      let dataSets = allLeafNodes.filter(item => {
        // prettier-ignore
        let bool = item.viewStatus !== 2 && dependentResourceTypes.includes(item.dataSetType);
        return bool
      })
      return dataSets
    },
    getClassName(schemeType) {
      let className = 'button-box'
      if (this.currSchemeType === schemeType) {
        className += ' active'
      }
      return className
    },
    findAllNodeByLevel(data, level) {
      const array = []

      const traverse = item => {
        if (item.nodeType === level) {
          array.push(item)
        }
        if (item.subNodes && item.subNodes.length) {
          item.subNodes.forEach(subNode => {
            traverse(subNode)
          })
        }
      }

      data.forEach(item => {
        traverse(item)
      })

      return array
    },
    findNodeByDataSetId(data, dataSetId) {
      for (const node of data) {
        if (node.dataSetId === dataSetId) return node
        if (node.subNodes && node.subNodes.length) {
          const res = this.findNodeByDataSetId(node.subNodes, dataSetId)
          if (res) return res
        }
      }
      return null
    },
    addAnchors(xCenter, yCenter, zCenter) {
      const BlackHole3D = window.BlackHole3D
      let picPath = ''
      let ancName = ''
      let picWidth = 0
      let picHeight = 0
      let entityInfo = this.currEntity.componentInfo
      if (entityInfo.hasAnimation) {
        ancName = 'twoBtn'
        picPath = this.getImgPath('bvIcon.png')
        picWidth = 68
        picHeight = 29
      } else {
        ancName = 'singleBtn'
        picPath = this.getImgPath('editPosn.png')
        picWidth = 32
        picHeight = 32
      }
      let ancList = [
        {
          groupName: 'dialogBtn',
          ancName,
          pos: [xCenter, yCenter, zCenter],
          picPath,
          textInfo: '',
          picWidth,
          picHeight,
          linePos: [0, 0],
          lineClr: new BlackHole3D.REColor(255, 0, 0, 255), //红色
          ancSize: 0,
          selfAutoScaleDist: -1,
          selfVisDist: -1,
          texBias: [0, 0],
          texFocus: [50, 0],
          uselod: false
        }
      ]
      BlackHole3D.Anchor.addAnc(ancList)
      BlackHole3D.Anchor.setAncCanOverlap('dialogBtn', false)
    },
    unloadDataSets(dataSetIds) {
      let domRef = this.$refs.engine
      domRef.unloadDataSets(dataSetIds)
    },
    unloadEntities(entity) {
      let dataSetId = entity.srcDataSetId
      dataSetId = dataSetId.replaceAll('-', '')

      const BlackHole3D = window.BlackHole3D
      let typeNames = BlackHole3D.Entity.getAllTypeNames(dataSetId)
      let entityInfo = {
        dataSetId,
        entityType: typeNames[0],
        elemIdList: [entity.elemId]
      }

      let domRef = this.$refs.engine
      domRef.unloadEntity(entityInfo)

      this.hiddenBVShp()
    },
    showDataSets(dataSets) {
      let domRef = this.$refs.engine
      domRef.showDataSets(dataSets)
    },
    hideDataSets(dataSets) {
      let domRef = this.$refs.engine
      domRef.hideDataSets(dataSets)
    },
    highLightDataSets(dataSets, isFocus) {
      let domRef = this.$refs.engine
      domRef.highLightDataSets(dataSets, isFocus)
    },
    highLightEntities(entities, isFocus) {
      let domRef = this.$refs.engine
      domRef.highLightEntities(entities, isFocus)
    },
    highLightWaters(waterIds) {
      let domRef = this.$refs.engine
      domRef.highLightWaters(waterIds)
    },
    showWaters(waterIds) {
      let domRef = this.$refs.engine
      domRef.showWaters(waterIds)
    },
    hideWaters(waterIds) {
      let domRef = this.$refs.engine
      domRef.hideWaters(waterIds)
    },
    highLightExtrudes(extrudeIds) {
      let domRef = this.$refs.engine
      domRef.highLightExtrudes(extrudeIds)
    },
    showExtrudes(extrudeIds) {
      let domRef = this.$refs.engine
      domRef.showExtrudes(extrudeIds)
    },
    hideExtrudes(extrudeIds) {
      let domRef = this.$refs.engine
      domRef.hideExtrudes(extrudeIds)
    },
    getImgPath(iconName) {
      let { origin, pathname } = window.location
      let iconPath = `${origin}${pathname.split('/index.html')[0]}`
      return `${iconPath}/engineIcon/${iconName}`
    },
    deleteCustomBtn(uiID) {
      window.BlackHole3D.Graphics.delWidget(uiID)
    },
    /**
     * 是否为单构件类型的构件
     */
    isEntityElem(elemInfo) {
      let allDataSets = this.findAllDataSets()
      let allEntityElems = allDataSets.filter(el =>
        elemDataSetType.includes(el.srcDataSetType)
      )

      let find = allEntityElems.find(item => {
        let dataSetId = item.srcDataSetId
        dataSetId = dataSetId.replaceAll('-', '')
        return elemInfo.dataSetId === dataSetId
      })

      return find
    },
    focusDataSets(dataSets) {
      let domRef = this.$refs.engine
      domRef.focusDataSets(dataSets)
    },
    focusEntities(focusEntities) {
      let domRef = this.$refs.engine
      domRef.focusEntities(focusEntities, false)
    },
    setEngineWorldCRS() {
      let domRef = this.$refs.engine
      domRef.setEngineWorldCRS('')
    },
    /**
     * 权限验证
     */
    isChecked(permissionCode) {
      let permissionData = Store.permissionData
      let find = permissionData.find(el => el.permissionCode === permissionCode)
      return find.isCheck
    }
  }
}
</script>

<style lang="less" scoped>
.scene-elememt-container {
  display: flex;
  flex-direction: column;
  height: calc(100% - 66px);
  margin-top: 2px;
  .menu-box {
    display: flex;
    height: 60px;
    background: var(--scene-edit-header-bgColor);
    flex-shrink: 0;
    border-bottom: 1px solid var(--scene-edit-header-border-color);

    .group-box {
      display: flex;
      padding: 0px 10px;
      border-right: 1px solid var(--scene-edit-header-border-color);

      &:last-child {
        border: none;
      }

      .button-box {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 60px;
        margin: auto 5px;
        padding: 6px 4px;
        font-size: 12px;
        line-height: 20px;
        cursor: pointer;
        color: var(--scene-edit-header-box-title-text-color);

        .icon-box {
          font-size: 14px;
        }

        &:hover {
          background: var(--scene-edit-header-box-title-hover-bgColor);
          color: var(--scene-edit-header-box-title-hover-text-color);
          border-radius: 8px;
        }
      }

      .active {
        background: var(--base-bg-light-color24) !important;
        border-radius: 8px;
        color: var(--base-primary-bgColor);
        .svg-icon {
          color: var(--base-primary-bgColor);
        }

        &:hover {
          background: var(--base-bg-light-color24);
        }
      }
    }
  }

  .scene-content-box {
    display: flex;
    height: calc(100% - 60px);

    .scene-data-box {
      flex-shrink: 0;
      .collapse-btn-box {
        position: absolute;
        top: 50%;
        left: 307px;
        display: flex;
        align-items: center;
        width: 24px;
        height: 40px;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        border-radius: 16px;
        background: var(--scene-edit-left-expand-bgColor);
        z-index: 1;
        border: 1px solid var(--scene-edit-left-expand-bgColor);
        border-left: none;
        box-shadow: var(--base-bg-dark-color30);

        &:hover {
          color: var(--base-primary-bgColor);
          background-color: var(--scene-edit-left-expand-hover-bgColor);
        }

        .icon-box {
          transform: rotate(180deg);
          cursor: pointer;
          color: var(--scene-edit-left-expand-icon-color);

          .icon-rotate {
            font-size: 16px;
            font-weight: 600;
          }
        }
      }

      .collapse {
        left: 0px;

        .icon-box {
          transform: rotate(0deg);
        }
      }
    }

    .engine-box {
      position: relative;
      flex-grow: 1;
      height: 100%;
      overflow: hidden;

      .icon-rotate {
        font-size: 16px;
        font-weight: 600;
      }

      .collapse-box {
        display: flex;
        position: absolute;
        bottom: 0px;
        margin-bottom: 5px;
        left: calc(50% - 45px);
        width: 90px;
        height: 20px;
        border-radius: 20px;
        line-height: 20px;
        background: #ffffff;
        z-index: 1;
        cursor: pointer;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        display: flex;
        justify-content: center;
        align-items: center;
        .icon {
          color: #0c2337;
          margin: auto;
        }

        &:hover {
          background: #f5f5f5;
          .icon-rotate {
            color: var(--base-primary-bgColor);
          }
        }
      }
    }

    .mouse-tip-box {
      position: absolute;
      top: 0px;
      left: 0px;
      margin-top: 10px;
      margin-left: 10px;
      padding: 10px;
      color: #ffffff;
      background: rgba(0, 0, 0, 0.2);
      box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
      text-align: left;
    }
  }
}
</style>
